/**
 * Helper styling and utility functions for isNew (Customer Type), isConverted (Conversion Status),
 * and Request/Order booking Source.
 */

export function getUserStatusBadge(isNew) {
  const normalized = (isNew || "").toLowerCase().trim();
  if (normalized === "new") {
    return {
      label: "New",
      badgeClass: "bg-emerald-50 text-emerald-700 border-emerald-200",
      dotClass: "bg-emerald-500",
      description: "0 lifetime orders placed",
    };
  }
  return {
    label: "Old / Returning",
    badgeClass: "bg-slate-100 text-slate-700 border-slate-200",
    dotClass: "bg-slate-500",
    description: "1 or more past orders",
  };
}

export function getConvertedBadge(isConverted) {
  const normalized = (isConverted || "").toLowerCase().trim();
  const isYes = normalized === "yes" || normalized === "true";

  if (isYes) {
    return {
      isConverted: true,
      label: "Yes",
      badgeClass:
        "bg-emerald-100 hover:bg-emerald-200 text-emerald-800 border-emerald-300 font-semibold cursor-pointer shadow-2xs transition-all hover:scale-105",
      dotClass: "bg-emerald-500",
    };
  }

  return {
    isConverted: false,
    label: "No",
    badgeClass:
      "bg-slate-100 hover:bg-slate-200 text-slate-600 border-slate-200 font-medium cursor-pointer shadow-2xs transition-all hover:scale-105",
    dotClass: "bg-slate-400",
  };
}

/**
 * Returns color mapping, label, and emoji icon for booking source.
 * Possible source_ids:
 * 28: AI Chat Bot
 * 7: Web
 * 2: Android App
 * 3: iOS App
 * 19: WhatsApp Chat
 * 27: SPC Executive App
 * 0, 1, 8: Admin Portal
 * null / Direct / Store: Direct / Store
 */
export function getSourceBadge(sourceId, sourceName) {
  const name = sourceName || (sourceId === 28 ? "AI Chat Bot" : "Direct / Store");

  if (sourceId === 28) {
    return {
      label: name,
      badgeClass: "bg-purple-100 text-purple-800 border border-purple-200",
      icon: "🤖 ",
    };
  }

  if (sourceId === 7) {
    return {
      label: name,
      badgeClass: "bg-blue-100 text-blue-800 border border-blue-200",
      icon: "🌐 ",
    };
  }

  if (sourceId === 2 || sourceId === 3) {
    return {
      label: name,
      badgeClass: "bg-teal-100 text-teal-800 border border-teal-200",
      icon: "📱 ",
    };
  }

  if (sourceId === 19) {
    return {
      label: name,
      badgeClass: "bg-emerald-100 text-emerald-800 border border-emerald-200",
      icon: "💬 ",
    };
  }

  if (sourceId === 27) {
    return {
      label: name,
      badgeClass: "bg-amber-100 text-amber-800 border border-amber-200",
      icon: "👔 ",
    };
  }

  if (sourceId === 0 || sourceId === 1 || sourceId === 8) {
    return {
      label: name,
      badgeClass: "bg-slate-100 text-slate-800 border border-slate-200",
      icon: "🖥️ ",
    };
  }

  return {
    label: name,
    badgeClass: "bg-gray-100 text-gray-800 border border-gray-200",
    icon: "🏪 ",
  };
}
